import Vue from 'vue'
import ip from 'ip';
import axios from 'axios'

const baseURL = process.env.VUE_APP_API_BASE_URL

const api = axios.create({
  baseURL
})

api.interceptors.response.use(function (response) {
  return response;
}, async function (error) {
  
  if (error.response && error.response.status === 401) {
    // Reset PostHog session and identity on logout
    try {
      if (window.posthog && typeof window.posthog.reset === 'function') {
        window.posthog.reset();
      }
    } catch (_) {}

    // Limpar completamente o localStorage e sessionStorage
    localStorage.clear();
    sessionStorage.clear();

    // Extrair o company_label da URL atual
    const pathParts = window.location.pathname.split('/').filter(part => part);
    const companyLabel = pathParts[0] || 'recrutei'; // Fallback para 'recrutei' se não houver label

    // Redirecionar para a página de signin do company
    window.location.href = `${window.location.origin}/${companyLabel}/signin`;
    
    // Retornar uma promise rejeitada para evitar que a requisição continue
    return Promise.reject(error);
  }
  return Promise.reject(error);
})

api.interceptors.request.use(async config => {
  // Adicionar token de autenticação em todas as requisições, exceto login, register e forgot-password
  if (
      !config.url.endsWith('login') &&
      !config.url.endsWith('register') &&
      !config.url.endsWith('forgot-password')
    ) {
    const token = await localStorage.getItem('userToken')
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
  }

  const clientIP = ip.address();
  config.headers['X-Forwarded-For'] = clientIP;

  return config
}, error => {
  return Promise.reject(error)
})

Vue.prototype.$http = api

export default api
